import React, { createContext, useContext, useState, useEffect } from 'react';
import { usePlayerContext } from '../Context';
import { VideoTrackEvents } from '../../sdk/PlayerEvents';
import { Events, State, VideoTrack } from '../../types/player';
import ControlMenu from '../ui/ControlMenu';
import SelectControl, { Item } from '../ui/SelectControl';

const VideoTracksSelector = () => {
  const { sdk } = usePlayerContext();

  const [videoTracks, setVideoTracks] = useState(sdk.getVideoTracks());
  let index = -1;
  const slug = 'videotrack';

  if (sdk.hasVideoTracks()) {
    index = sdk.getCurrentVideoTrack().index as number;
  }
  const [currentVideoTrackIndex, setCurrentVideoTrackIndex] = useState(index);

  useEffect(() => {
    sdk.on(Events.VIDEOTRACK_CHANGED, (event: VideoTrackEvents) => {
      setCurrentVideoTrackIndex(event.index);
    });
  }, []);

  function setCurrentVideoTrack(index: string) {
    sdk.setCurrentVideoTrack(parseInt(index));
    sdk.toggleControlMenu(slug);
  }

  function getVideoTrackLabel(videoTrack: VideoTrack) {
    let hook = sdk.options().getLocale()?.hooks?.videoTrackLabel;
    if (hook) {
      const customLabel = hook(videoTrack);
      if (customLabel) return customLabel;
    }
    return `${videoTrack.label}`;
  }

  if (!sdk.hasVideoTracks()) {
    return null;
  }

  const items: Item[] = [];
  videoTracks.map((videoTrack, index) => {
    items.push({
      val: index,
      label: getVideoTrackLabel(videoTrack),
    });
  });

  const selector = (
    <div
      className={`${sdk.getClassNamePrefix()}-player-control-menu-list ${sdk.getClassNamePrefix()}-player-control-menu-list-${slug}`}
    >
      <SelectControl
        items={items}
        controlSlug={slug}
        currentValue={currentVideoTrackIndex}
        handleAction={setCurrentVideoTrack}
      />
    </div>
  );

  if (!sdk.hasVideoTracks()) {
    return null;
  }

  return (
    <ControlMenu
      icon={'headphones'}
      controlClassName={'videotrack'}
      title={'Video track'}
      content={selector}
    />
  );
};

export default VideoTracksSelector;
